// extracted by mini-css-extract-plugin
export default {"loader":"CssLoader_loader__B7Fr8","spin":"CssLoader_spin__XLlB6"};